import React, { useState } from 'react';
import "../assets/css/summary.css";
import { centralCall } from '../api';
import { useSharedDataContext } from './SharedDataContext';
import AddonSummaryCard from './ChildComp/AddonSummaryCard';
import { useHistory } from 'react-router-dom';
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";

const Summary = (props) => {
    const { sharedData, setSharedData , sharedQuoteData} = useSharedDataContext();
    const [htmlContent, setHtmlContent] = useState('');
    const [callpayment, setcallpayment] = useState(true);
    const [downloadProposalPDF, setDownloadProposalPDF] = useState(false);
    const history = useHistory();

    const constructPaymentModel = () => {
        return {
            "EnquiryNo": sharedData.enquiryno,
            "PayAmount": sharedData.TotalPremium,
            "CompanyID": sharedQuoteData.InsurerID
        };
    };
    const policyenddate = new Date();


    // Define options for formatting the date
    const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    };
    // Use the toLocaleDateString method to format the date

    const PayNow = () => {
        if (callpayment) {

            try {
                const paymentmodel = constructPaymentModel();
                centralCall({ URL: '/api/Payment/GetPayment', Request: paymentmodel, IsPost:true })
                    //fetchPayment(paymentmodel)
                    .then(res => {
                        const data = res.data;
                        if (data.Data.PaymentGatewayStatus) {
                            if (data.Data.IsRedirectUrl === false) {
                                setHtmlContent(data.Data.PaymentHTML);
                                openHtmlInNewWindow(data.Data.PaymentHTML);
                                //openHtmlInNewWindow();
                            }
                        }

                    })
            } catch (error) {
                console.error('Error fetching payment data:', error);
            }

        }
    }

    const openHtmlInNewWindow = (htmlContent) => {
        // Create a new HTML document in a new tab
        const newWindow = window.open('', '_self');
        if (newWindow) {
            // Write the HTML content to the new tab
            newWindow.document.write(htmlContent);
            newWindow.document.close();

            // Automatically submit the form when the page loads
            newWindow.onload = () => {
                newWindow.document.forms[0].submit();
            };
        } else {
            // Handle popup blocked error
            console.error('Popup blocked');
        }
    };

    const generatePropPDF = async() => {
        setDownloadProposalPDF(true);
        const element = document.getElementById('propPDF');
       /* let payBtn = document.getElementById('payNowBtn');
        const arwBtn = document.getElementById('arrowBtn');
        if (payBtn) payBtn.remove();
        if (arwBtn) arwBtn.remove();*/
        let option = {
            margin: 0,
            filename: (sharedData.enquiryno || '').replace('/', '_') + "_Proposal" + "_Summary.pdf",
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 8, letterRendering: true, useCORS: true, dpi: 192 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: element.scrollHeight,
            // pagebreak: { mode: 'avoid-all', before: '.part2break' }
        }

        try {

            await html2pdf().set(option).from(element).save();
            setDownloadProposalPDF(false);

        } catch (error) {
            console.log({ error });
        }

    }

    return (<>
    
            {downloadProposalPDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
        <div className="Summery" id='propPDF'>
            <div className="container" >
                <div className="BackBTNRow" id='arrowBtn'>
                    <a className="arw-btn"  onClick={() => history.goBack()}>
                        <i className="fas fa-long-arrow-alt-left mx-1"></i>
                        <span>Back to Proposal</span>
                    </a>
                </div>
                <div className="row">
                    <div className="col-md-9">
                        <div className="owner_detailbox">
                            <h3>Owner Details</h3>
                            <div className="owner_detail">
                                <ul>
                                    <li>
                                        <span>Name</span>
                                        <p>{sharedData.ownername}</p>
                                    </li>
                                    <li>
                                        <span>Date Of Birth</span>
                                        <p>{sharedData?.proposalmodel?.DoB?.split("-").reverse().join("-")}</p>
                                    </li>
                                    <li>
                                        <span>Gender</span>
                                        <p>{(sharedData.proposalmodel.Gender == "M" ? "Male" : "Female")}</p>
                                    </li>
                                    <li>
                                        <span> Email </span>
                                        <p>{sharedData.proposalmodel.EmailId}</p>
                                    </li>
                                    <li>
                                        <span> Mobile </span>
                                        <p>{sharedData.proposalmodel.MobileNo}</p>
                                    </li>
                                    <li className="owner_address">
                                        <span>  Address </span>
                                        <p>{sharedData.proposalmodel.Address1},
                                            {sharedData.proposalmodel?.Address2},
                                            {sharedData.proposalmodel?.Address3},
                                            {sharedData.proposalmodel?.City},
                                            {sharedData.proposalmodel.StateCode},
                                            {sharedData.proposalmodel.PinCode}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="owner_detailbox">
                            <h3>Pet Details</h3>
                            <div className="owner_detail">
                                <ul>
                                    <li>
                                        <span>Pet Name </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].PetName}</p>
                                    </li>
                                    <li>
                                        <span> Age </span>
                                        <p>{Math.round(sharedData.proposalmodel.PetDetails[0].Age / 12)} {Math.round(sharedData.proposalmodel.PetDetails[0].Age / 12) > 1 ?"Years": "Year"} {sharedData.proposalmodel.PetDetails[0].Age - (Math.round(sharedData.proposalmodel.PetDetails[0].Age / 12) * 12)} {sharedData.proposalmodel.PetDetails[0].Age - (Math.round(sharedData.proposalmodel.PetDetails[0].Age / 12) * 12) > 1 ? " Months" :"Month"}</p>
                                    </li>
                                    <li>
                                        <span> Gender </span>
                                        <p>{(sharedData.proposalmodel.PetDetails[0].Gender == "M" ? "Male" : "Female")}</p>
                                    </li>
                                    <li>
                                        <span>  Weight </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].Weight}</p>
                                    </li>
                                    <li>
                                        <span> Breed </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].Breed}</p>
                                    </li>
                                    <li>
                                        <span> Breed Catagory</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].BreedCategory}</p>
                                    </li>
                                    <li>
                                        <span> Features</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].Features ? sharedData.proposalmodel.PetDetails[0].Features :"None"}</p>
                                    </li>
                                    <li>
                                        <span > Identification Mark </span>
                                        <p className="text-capitalize">{sharedData.proposalmodel.PetDetails[0].Identification}</p>
                                    </li>
                                    <li>
                                        <span> Tag Number </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].TagNo ? sharedData.proposalmodel.PetDetails[0].TagNo  : "None" }</p>
                                    </li>
                                    <li >
                                        <span>  Is the dog's used for commercial purpose? </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].HasCommercialUse ? "Yes" : "No"}</p>
                                    </li>
                                    {sharedData.proposalmodel.PetDetails[0].HasCommercialUse&& <li >
                                        <span>Commercial Use Details</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].CommercialUseDetails}</p>
                                    </li>}
                                    <li >
                                        <span>  Is the dog's already insured elsewhere?</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].HasOtherInsurance ? "Yes" : "No"}</p>
                                    </li>
                                    {sharedData.proposalmodel.PetDetails[0].HasOtherInsurance &&
                                        (<>
                                            <li >
                                            <span>Insurer Name</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].OtherInsurerName }</p>
                                        </li>
                                        <li >
                                            <span>Other Insurance Policy No</span>
                                            <p>{sharedData.proposalmodel.PetDetails[0].OtherInsurancePolicyNo }</p>
                                        </li>
                                        </>)}
                                </ul>
                            </div>
                        </div>
                        <div className="owner_detailbox">
                            <h3>Medical History</h3>
                            <div className="owner_detail">
                                <ul>
                                    <li className="owner_address">
                                        <span> Is your pet dog sound and healthy? </span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].IsPetIll ? "No" : "Yes"}</p>
                                    </li>
                                    <li className="owner_address">
                                        <span> Any Pre-existing disease/conditions Pet Dog(s) suffers from?</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].AnyPreExistingDisese ? "Yes" : "No"}</p>
                                    </li>
                                    <li className="owner_address">
                                        <span>Vaccinations has been given to your Pet</span>
                                        <p>{sharedData.proposalmodel.PetDetails[0].Vaccinations.join(', ')}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


               
                    <div className="col-md-3">
                        <AddonSummaryCard isOnSummaryPage={true} payNow={PayNow} />
                        <div>
                            <img src={require('../../src/assets/images/Group 2913.svg').default} />
                        </div>
                    </div>


                </div>
                    <div className="CallRequest ">
                    <button className="showOpt" onClick={generatePropPDF} id="MoreOption">
                        <span className="text-white"><BsStars /></span>
                        <span className="text-white"><FaRegFilePdf /></span>
                        <span className="text-white">Generate PDF</span>
                        </button>
                    </div>
            </div>
        </div>
    </>);
}
export default Summary;
